import { render, staticRenderFns } from "./ApexClubDetail.vue?vue&type=template&id=03ed86f4&scoped=true"
import script from "./ApexClubDetail.vue?vue&type=script&lang=js"
export * from "./ApexClubDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ed86f4",
  null
  
)

export default component.exports